import { render, staticRenderFns } from "./FreightRate.vue?vue&type=template&id=5227957e&scoped=true"
import script from "./FreightRate.vue?vue&type=script&lang=js"
export * from "./FreightRate.vue?vue&type=script&lang=js"
import style0 from "./FreightRate.vue?vue&type=style&index=0&id=5227957e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5227957e",
  null
  
)

export default component.exports